module.exports = __webpack_public_path__ + "img/p3.2babf1f8.png";